import GeneralTemplate from './general'

Simple = GeneralTemplate({})

export default Simple